import { resolveAppData } from '@/logic/app-data';
import { isNativeApiAllowedRoute } from '@/logic/app-data/app-data-route';
import { getPageConfig } from '@/lib/aggregation';
import type { Experiment } from '@/types/aggregation/home';

export const getExperiments = async ({ currentRoute }: { currentRoute: string }): Promise<Experiment> => {
    if (!isNativeApiAllowedRoute(currentRoute)) {
        return (await getPageConfig(currentRoute))?.experiments ?? {};
    }
    return (await resolveAppData(currentRoute))?.experiments ?? {};
};
